import Select from "react-select";
import { FormattedMessage, useIntl } from "react-intl";
import { GetSchoolsForAdmin } from "../../actions/adminQueries";
import { compareByName } from "../../Utilities/sortHelper";

// Markeringen är blå, utom på det valda alternativet i listan: där är bakgrunden blå och
// texten ska ärva färgen.
const formatOptionLabel = (option, { context, selectValue }) => {
  const isSelectedInMenu =
    context === "menu" &&
    selectValue.some((selected) => selected.value === option.value);

  return (
    <>
      {option.label}
      {option.isCurrent && (
        <span className={isSelectedInMenu ? "ms-1" : "text-primary ms-1"}>
          <FormattedMessage id="CurrentMarker" />
        </span>
      )}
    </>
  );
};

// Väljare för skola och klass. value är { schoolId, classId }; byts skola nollställs klassen.
// currentSchoolIds och currentClassIds markerar var användaren redan finns med "(nuvarande)".
export default function SchoolClassPicker({
  value,
  onChange,
  currentSchoolIds = [],
  currentClassIds = [],
}) {
  const intl = useIntl();
  const schoolsQuery = GetSchoolsForAdmin();

  const schools = [...(schoolsQuery.data?.schools ?? [])].sort(compareByName);
  const schoolOptions = schools.map((school) => ({
    value: school.id,
    label: `${school.name} (${school.fortKnoxCustomerNumber})`,
    isCurrent: currentSchoolIds.includes(school.id),
  }));

  const selectedSchool = schools.find((school) => school.id === value.schoolId);
  const classOptions = (selectedSchool?.programmes ?? [])
    .flatMap((programme) => programme.classes ?? [])
    .sort(compareByName)
    .map((schoolClass) => ({
      value: schoolClass.id,
      label: schoolClass.name,
      isCurrent: currentClassIds.includes(schoolClass.id),
    }));

  return (
    <>
      <Select
        className="mb-2"
        isLoading={schoolsQuery.isLoading}
        options={schoolOptions}
        value={
          schoolOptions.find((option) => option.value === value.schoolId) ??
          null
        }
        onChange={(option) =>
          onChange({ schoolId: option?.value ?? null, classId: null })
        }
        formatOptionLabel={formatOptionLabel}
        placeholder={intl.formatMessage({ id: "SelectSchoolPlaceholder" })}
      />
      <Select
        className="mb-3"
        isDisabled={!selectedSchool}
        options={classOptions}
        value={
          classOptions.find((option) => option.value === value.classId) ?? null
        }
        onChange={(option) =>
          onChange({ ...value, classId: option?.value ?? null })
        }
        formatOptionLabel={formatOptionLabel}
        placeholder={intl.formatMessage({ id: "SelectClassPlaceholder" })}
        noOptionsMessage={() => intl.formatMessage({ id: "NoClassesInSchool" })}
      />
    </>
  );
}
